import { I18n } from '@calendly/i18n';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, useState, forwardRef } from 'react';
import { useGetMeetingIntelligenceUserSettingsQuery, useUpdateUserMeetingIntelligenceDataMutation } from 'features/meeting_intelligence';
const containerIsDesktopUpCss = "c12w2sd8";
const containerCss = "c1yq451u";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isDesktopUp = useDeviceType('isDesktopUp');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsDesktopUpCss]: isDesktopUp
  }, props.className)} />;
});
const subheaderCss = "scg7ngx";
const Subheader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subheaderCss, props.className)} />;
});
const switchContainerCss = "s1cs45o1";
const SwitchContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(switchContainerCss, props.className)} />;
});
export const MeetingBriefSettingSection = () => {
  const {
    data,
    isLoading,
    refetch
  } = useGetMeetingIntelligenceUserSettingsQuery();
  const [updateUserMeetingIntelligenceData] = useUpdateUserMeetingIntelligenceDataMutation();
  const [meetingBriefEmailsEnabled, setMeetingBriefEmailsEnabled] = useState(null);
  useEffect(() => {
    if (data) {
      setMeetingBriefEmailsEnabled(!!data.meetingBriefEmailsEnabled);
    }
  }, [data]);
  const handleChange = async () => {
    if (meetingBriefEmailsEnabled !== null) {
      const newValue = !meetingBriefEmailsEnabled;
      try {
        await updateUserMeetingIntelligenceData({
          meeting_brief_emails_enabled: newValue
        });
        setMeetingBriefEmailsEnabled(newValue);
        refetch();
      } catch (error) {
        console.error('Failed to update setting:', error);
      }
    }
  };
  const checked = !isLoading && meetingBriefEmailsEnabled ? meetingBriefEmailsEnabled : false;
  return <Container>
      <Subheader>{I18n.t('publisher.account_settings.meeting_intelligence.communication_settings.meeting_digest_emails')}</Subheader>
      <SwitchContainer>
        <label htmlFor="meeting-brief-emails-enabled">
          <SwitchInput id="meeting-brief-emails-enabled" checked={checked} onChange={() => handleChange()} disabled={isLoading} aria-label={I18n.t('publisher.account_settings.meeting_intelligence.communication_settings.meeting_digest_emails_toggle_label')} />
        </label>
        {I18n.t('publisher.account_settings.meeting_intelligence.communication_settings.meeting_digest_emails_toggle_label')}
      </SwitchContainer>
    </Container>;
};

require("./meeting_digest_section.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./meeting_digest_section.js");